import { render, staticRenderFns } from "./GroupEvents.tab.vue?vue&type=template&id=7b622337&"
import script from "./GroupEvents.tab.vue?vue&type=script&lang=ts&"
export * from "./GroupEvents.tab.vue?vue&type=script&lang=ts&"
import style0 from "./GroupEvents.tab.vue?vue&type=style&index=0&lang=css&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports